module.exports = __webpack_public_path__ + "static/media/T0-Google__Cloud__Platform.920782bb.svg";